<template>
  <div class="home-page">
    <div class="first-box">
      <img class="main-logo" src="../../../public/static/indexUse/logo.png" alt="AIJU SCHOOL" />
      <div class="explore-more" @click="scrollToSecond">
        <span>{{ $t('探索更多') }}</span>
        <dol-icon type="DownOutlined" />
      </div>
    </div>

    <div class="second-box" ref="secondBox">
      <div class="box-container">
        <div class="left-content">
          <div>
            <h2 class="title">{{ $t('爱知博艺 菊雅竞芳') }}</h2>
            <p class="desc">{{ $t('在爱菊') }}</p>
          </div>
          <div class="tag-list">
            <div v-for="tag in tagList" :key="tag.id" class="tag-item" :class="`tag-${tag.id}`">
              <div class="tag-name">{{ $t(tag.name) }}</div>
              <div class="tag-desc">{{ $t(tag.desc) }}</div>
            </div>
          </div>
        </div>
        <div class="right-content">
          <img class="campus-img" src="../../../public/static/indexUse/index-1.png" alt="校园生活" />
          <div class="img-desc-box">
            <div class="img-title">{{ $t('校园生活') }}</div>
            <div class="img-desc">{{ $t('校园坐落') }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="third-box">
      <div class="third-container">
        <div class="third-title">{{ $t('爱菊教育') }}</div>
        <a-row :gutter="[12,12]">
          <a-col v-for="item in eduList" :key="item._id" :span="item.span">
            <div class="edu-item" @click="$router.push(item.page?.link || item.page?._id)">
              <img class="edu-img" :src="getImagePath(item)" />
              <div class="edu-text">{{ $dt(item.page, 'name') }}</div>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>

    <div class="fourth-box">
      <div class="fourth-container">
        <div class="fourth-title">{{ $t('新闻与活动') }}</div>
        <a-row class="news-list" :gutter="26">
          <a-col span="8" v-for="item in newsList" :key="item._id">
            <div class="news-item" @click="goNewsDetail(item)">
              <img class="news-img" :src="$Dolphin.path.publicPath + $dt(item,'image').filePath" />
              <div class="news-title">{{ $dt(item, 'title') }}</div>
              <div class="news-content">{{ $dt(item, 'remark') }}</div>
              <div class="news-createTime">{{ $dayjs(item.updateTime).format('YYYY-MM-DD') }}</div>
            </div>
          </a-col>
        </a-row>
        <div class="button-row">
          <div class="as-button" @click="$router.push('/news')">{{ $t('查看更多') }}</div>
        </div>
      </div>
    </div>

    <template v-if="adInfo">
      <!--      {{adInfo}}-->
      <div class="ad-open" v-if="adOpen">
        <div class="ad-close-btn" @click="adOpen = false">×</div>
        <img class="ad-img" :src="$Dolphin.path.publicPath + adInfo.backgroundImage?.filePath" />
        <!--        <div class="ad-box">-->
        <div class="ad-open-inside">
          <div class="ad-title" v-if="adInfo.name"> {{ $dt(adInfo, 'title') }}</div>
          <img class="ad-image" :src="getImagePath(adInfo)" />
        </div>
        <!--        </div>-->
      </div>
      <div class="ad-close" v-else @click="adOpen = true">
        <img :src="$Dolphin.path.publicPath + adInfo.backgroundImage?.filePath" />
      </div>
    </template>
  </div>
</template>

<script>

export default {
  name: "home",
  data() {
    return {
      adOpen: false,
      adInfo: null,
      tagList: [
        { id: 1, name: '爱知', desc: '热爱知识，夯实基础' },
        { id: 2, name: '博艺', desc: '通晓科艺，增长才干' },
        { id: 3, name: '菊雅', desc: '举止优雅，高雅情趣' },
        { id: 4, name: '竞芳', desc: '合作自信，全面发展' },
      ],
      isScrolling: false,
      newsList: [],
      eduList: [],
    };
  },
  methods: {
    scrollToSecond() {
      // this.$refs.secondBox.scrollIntoView({ behavior: 'smooth' });

      const headerHeight = 156; // 对应header的固定高度80px
      const target = this.$refs.secondBox;
      const targetTop = target.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: targetTop - headerHeight,
        behavior: 'smooth'
      });
    },
    handleWheel(e) {
      if (this.isScrolling) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isTop = scrollTop < 100;
      const isDown = e.deltaY > 0;

      if (isTop && isDown) {
        e.preventDefault();
        this.isScrolling = true;
        this.scrollToSecond();
        setTimeout(() => {
          this.isScrolling = false;
        }, 1000);
      }
    },
    queryNews() {
      this.$ajax({
        url: '/portal/newsList',
        method: 'post',
        data: { type: '', searchStr: '', activeFlag: true },
        params: { pageNumber: 0, pageSize: 3 }
      }).then(({ rows }) => {
        this.newsList = rows;
      })
    },
    goNewsDetail(item) {
      this.$router.push(`/newsDetail?id=${item._id}`);
    },
    queryEdu() {
      this.$ajax({ url: '/portal/homeEduFind', }).then(({ rows }) => {
        this.eduList = rows;
      });
    },
    getImagePath(item) {
      const image = this.$dt(item, 'image') || item.image;
      if (!image) return '';
      return this.$Dolphin.path.publicPath + image.filePath;
    },
    queryAd() {
      this.$ajax({ url: '/portal/queryCommonConfig', params: { code: 'homeAd' } }).then(({ data }) => {
        this.adInfo = data;
        this.adOpen = !!data;
      });
    },
  },
  created() {
    this.queryNews();
    this.queryEdu();
    this.queryAd();
  },
  mounted() {
    // window.addEventListener('wheel', this.handleWheel, { passive: false });
  },
  beforeUnmount() {
    // window.removeEventListener('wheel', this.handleWheel);
  },
};
</script>

<style scoped lang="scss">
.home-page {
  width: 100%;

  .ad-open {
    position: fixed;
    right: 0;
    bottom: 120px;
    width: 180px;
    // 背景渐变色 上5AA1FF 下E5F0FF
    background: linear-gradient(180deg, #5AA1FF 0%, #E5F0FF 100%);
    padding: 8px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .ad-img {
      width: 80%;
      //margin-bottom: 4px;
    }

    .ad-close-btn {
      position: absolute;
      right: 0;
      top: 0;
      padding: 8px;
      cursor: pointer;
      font-size: 16px;
      color: white;
    }

    .ad-open-inside {
      background: linear-gradient(180deg, #DDECFF 0%, #FFFFFF 100%);
      padding: 12px;
      border-radius: 12px;
    }

    .ad-title {
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      color: #003C82;
      margin-bottom: 6px;
    }

    .ad-image {
      width: 100%;
    }
  }

  .ad-close {
    position: fixed;
    right: 0;
    bottom: 120px;
    width: 100px;
    height: 100px;
    padding: 0 4px;
    border-radius: 50% 0 0 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background-color: #1a7cfe;

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  .first-box {
    width: 100%;
    height: 700px;
    background: url("../../../public/static/indexUse/bg.png") no-repeat center / cover;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .main-logo {
      height: 220px;
      width: auto;
      object-fit: contain;
    }

    .explore-more {
      position: absolute;
      bottom: 32px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      color: #fff;
      font-size: 14px;
      cursor: pointer;
      transition: opacity 0.3s ease;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .second-box {
    width: 100%;
    height: 650px;
    margin: 96px 0;
    box-sizing: border-box;

    .box-container {
      width: 1280px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 120px;

      .left-content {
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .title {
          font-size: 22px;
          font-weight: bold;
          color: #003C82;
          margin: 0 0 16px 0;
          line-height: 1.4;
        }

        .desc {
          font-size: 14px;
          color: #333;
          line-height: 1.6;
          margin: 0 0 40px 0;
        }

        .tag-list {
          display: flex;
          flex-wrap: wrap;

          .tag-item {
            width: 50%;
            display: flex;
            flex-direction: column;
            gap: 8px;

            .tag-name {
              width: 120px;
              height: 120px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 32px;
              font-weight: bold;
              margin: 0 12px 16px;
              text-align: center;
            }

            .tag-desc {
              width: 144px;
              font-size: 16px;
              text-align: center;
              margin-bottom: 36px;
            }

            &.tag-1 {
              color: #CD497E;

              .tag-name {
                background: rgba(#CD497E, 0.2);
              }
            }

            &.tag-2 {
              color: #5D9947;

              .tag-name {
                background: rgba(#5D9947, 0.2);
              }
            }

            &.tag-3 {
              color: #DEA128;

              .tag-name {
                background: rgba(#DEA128, 0.2);
              }
            }

            &.tag-4 {
              color: #32689E;

              .tag-name {
                background: rgba(#32689E, 0.2);
              }
            }
          }
        }
      }

      .right-content {
        flex: 1;
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;

        .campus-img {
          width: 100%;
          height: 100%;
        }

        .img-desc-box {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 230px;
          padding: 30px 158px 30px 32px;
          background: linear-gradient(180deg, rgba(0, 60, 130, 0) 0%, #003C82 100%);
          color: #fff;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;

          .img-title {
            font-size: 24px;
            font-weight: bold;
            margin-bottom: 12px;
          }

          .img-desc {
            font-size: 16px;
            line-height: 1.5;
          }
        }
      }
    }
  }

  .third-box {
    background: url("../../../public/static/indexUse/thirdBg.png") no-repeat center / cover;
    padding: 96px 0;

    .third-container {
      width: 1280px;
      margin: auto;

      .third-title {
        font-weight: 600;
        font-size: 32px;
        color: #FFFFFF;
        text-align: center;
        margin-bottom: 32px;
      }

      .edu-item {
        position: relative;
        transition: all 0.2s ease;
        cursor: pointer;
        height: 100%;

        &:hover {
          transform: scale(1.02);
          box-shadow: 0 16px 32px rgba(0, 30, 70, 0.25), 0 8px 16px rgba(0, 30, 70, 0.18);
          z-index: 10;
        }
      }

      .edu-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .edu-text {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        display: flex;
        align-items: flex-end;
        padding: 32px;
        font-weight: 600;
        font-size: 20px;
        color: #FFFFFF;
      }
    }
  }

  .fourth-box {
    background-color: white;
    padding: 96px 0;

    .fourth-container {
      width: 1280px;
      margin: auto;

      .fourth-title {
        font-size: 32px;
        color: #003C82;
        margin-bottom: 24px;
        font-weight: bold;
      }

      .no-data {
        color: #999999;
        padding: 24px;
        font-size: 16px;
        text-align: center;
      }

      .news-item {
        position: relative;
        cursor: pointer;
        height: 100%;
      }

      .news-img {
        width: 100%;
        height: 280px;
        object-fit: cover;
        object-position: center;
        margin-bottom: 16px;
      }

      .news-title {
        font-size: 20px;
        color: #003C82;
        line-height: 28px;
        font-weight: bold;
        margin-bottom: 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .news-content {
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        margin-bottom: 8px;
      }

      .news-createTime {
        color: #999999;
        line-height: 20px;
      }
    }

    .button-row {
      display: flex;
      justify-content: center;
      margin-top: 36px;

      .as-button {
        display: inline-block;
        padding: 22px 74px;
        background-color: #003C82;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 28px;
        font-weight: bold;
        cursor: pointer;
      }
    }
  }

}
</style>
